import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import BrokersSection from './components/BrokersSection';
import FeaturesPreview from './components/FeaturesPreview';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <BrokersSection />
        <FeaturesPreview />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}